import { Box, ListItem, styled, useTheme } from '@mui/material';
import { PoolAvatar, PoolTypography } from '@synergy/components-next';
import { PropsWithChildren, ReactElement } from 'react';
import { UserIcon } from '@synergy/theme-next';
import { shouldForwardPropExclude } from '@synergy/utils';

import { useAppSelector } from '../../../../../store/store';
import { userSelector } from '../../../../store/configuration-selectors';

const AccountListItem = styled(ListItem, { shouldForwardProp: shouldForwardPropExclude('clickable') })<{
    clickable: boolean;
}>(({ theme, clickable }) => ({
    color: theme.palette.common.white,
    gap: '12px',
    padding: '12px 16px 16px',
    backgroundColor: theme.palette.grey[900],
    alignItems: 'flex-start',
    minHeight: 79.5,

    '&:hover': {
        backgroundColor: theme.palette.grey[900],
        cursor: clickable ? 'pointer' : 'default',
    },
}));

interface UserItemProps {
    firstName?: string;
    lastName?: string;
    accountName?: string;
    onClick?: () => void;
}

export const UserItem = (props: PropsWithChildren<UserItemProps>): ReactElement => {
    const theme = useTheme();
    const user = useAppSelector(userSelector);
    const { firstName, lastName, accountName, onClick } = props;

    const marginTop = !onClick ? theme.spacing(1.75) : 'auto';
    const marginBottom = onClick && 'auto';

    return (
        <AccountListItem onClick={onClick} clickable={!!onClick}>
            {onClick ? (
                <Box sx={{ marginTop: 'auto', marginBottom: 'auto', width: 32, textAlign: 'center' }}>
                    <UserIcon />
                </Box>
            ) : (
                <PoolAvatar
                    firstName={firstName ?? ''}
                    lastName={lastName}
                    sx={{ backgroundColor: theme.palette.common.black, mt: 1 }}
                />
            )}
            <Box sx={{ mt: marginTop, mb: marginBottom, display: 'flex', flexDirection: 'column' }}>
                <PoolTypography variant="subtitle2">
                    <strong>{user?.fullName}</strong>
                </PoolTypography>
                <PoolTypography variant="caption" sx={{ whiteSpace: 'pre-wrap' }}>
                    {accountName}
                </PoolTypography>
            </Box>
            {props.children}
        </AccountListItem>
    );
};
